export const getThemeValue = (theme) => {
    if (theme === 'dark') {
        return 'white';
    } else {
        return 'black';
    }
};